import { Outlet } from 'react-router-dom';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { Separator } from '@/components/ui/separator';
import { AppSidebar } from './AppSidebar';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';
import { Breadcrumbs } from './Breadcrumbs';
import { AutopilotBanner } from '@/features/autopilot/AutopilotBanner';
import { useRealtime } from '@/hooks/useRealtime';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export function AppLayout() {
  const { connected } = useRealtime();
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="sticky top-0 z-10 flex h-14 shrink-0 items-center gap-2 border-b bg-background/80 px-4 backdrop-blur">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 h-4" />
          <Breadcrumbs />
          <div className="ml-auto flex items-center gap-2">
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="flex items-center gap-1.5 text-xs text-muted-foreground">
                  <span
                    className={cn(
                      'size-2 rounded-full',
                      connected ? 'bg-success' : 'bg-muted-foreground/40',
                    )}
                  />
                  {connected ? 'Ao vivo' : 'Offline'}
                </span>
              </TooltipTrigger>
              <TooltipContent>
                {connected ? 'Atualizações em tempo real ativas' : 'Sem conexão em tempo real'}
              </TooltipContent>
            </Tooltip>
            <ThemeToggle />
            <UserMenu />
          </div>
        </header>
        <AutopilotBanner />
        <main className="min-w-0 flex-1 p-4 md:p-6">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
